// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Directive } from '@angular/core';

@Directive({
  selector: '[appCalcSubtableColumnWidth]',
  standalone: true,
  host: {
    '[style.grid-template-columns]': 'this.gridTemplateColumns()',
  },
})
export class CalcSubtableColumnWidthDirective {
  public gridTemplateColumns(): string {
    const { created, ticketNumber, subject, operationalState, status } =
      this.columnsWidth();

    return `minmax(calc(var(--sh-table-cell-first-nested-padding) + 114px), ${created}px) 
            minmax(369px, ${ticketNumber + subject}px) 
            minmax(176px, ${operationalState}px) 
            minmax(133px, ${status}px)
          `;
  }

  private columnsWidth(): { [key: string]: number } {
    return {
      header: this.elementWidth('#sp-table-header'),
      created: this.elementWidth('#sp-header-created'),
      ticketNumber: this.elementWidth('#sp-header-ticket-number'),
      subject: this.elementWidth('#sp-header-subject'),
      operationalState: this.elementWidth('#sp-header-operational-state'),
      status: this.elementWidth('#sp-header-status'),
    };
  }

  private elementWidth(elementIdSelector: string): number {
    const localEl = document.querySelector(elementIdSelector);
    return localEl?.clientWidth ?? 0;
  }
}
